exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user_transfer .min_cla{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.user_transfer label[role=checkbox]{display:block}.user_transfer .el-transfer{width:100%}.user_transfer .el-transfer-panel{width:40%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0c1b2786","scoped":false,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":12}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/cdpBase/baseComponents/userTransfer/src/main.vue
// module id = MNwl
// module chunks = 19